import React from 'react';
import { applyProfileAvatarImgFallback } from '../../../../MainHeader/profilePictureUrl';
import { createPortal } from 'react-dom';
import { FiGrid, FiHome, FiMessageSquare, FiPlus, FiUser, FiUsers } from 'react-icons/fi';

/**
 * Mobile-only floating create FAB (scroll up) and bottom icon bar (scroll down).
 * Bar order: Home → Messages → Create → Connections → Profile
 */
export default function PostsMobileFloatingChrome({
  chromeMode = 'bar',
  hidden = false,
  onHome,
  onMessages,
  onCreate,
  onSocial,
  onProfile,
  isHomeActive = false,
  isMessagesActive = false,
  isCreateActive = false,
  isSocialActive = false,
  isProfileActive = false,
  profileAvatarSrc = '',
  profileUserId = '',
  profileDisplayName = '',
  showProfileAvatar = false,
  hasUnreadMessages = false,
}) {
  if (hidden || typeof document === 'undefined') return null;

  const showBar = chromeMode === 'bar';
  const showFab = chromeMode === 'fab';

  return createPortal(
    <div
      className={`posts-mobile-floating-chrome${showBar ? ' posts-mobile-floating-chrome--bar' : ''}${
        showFab ? ' posts-mobile-floating-chrome--fab' : ''
      }`}
      aria-hidden={false}
    >
      {showFab ? (
        <button
          type="button"
          className={`posts-mobile-floating-chrome__fab noOutline-text${isCreateActive ? ' is-active' : ''}`}
          onClick={onCreate}
          aria-label="Create post"
        >
          <FiPlus aria-hidden />
        </button>
      ) : null}

      {showBar ? (
        <nav className="posts-mobile-floating-chrome__bar" aria-label="Quick navigation">
          <button
            type="button"
            className={`posts-mobile-floating-chrome__bar-btn noOutline-text${
              isHomeActive ? ' is-active' : ''
            }`}
            onClick={onHome}
            aria-label="Home"
            aria-current={isHomeActive ? 'page' : undefined}
          >
            {showProfileAvatar ? <FiGrid aria-hidden /> : <FiHome aria-hidden />}
          </button>
          <button
            type="button"
            className={`posts-mobile-floating-chrome__bar-btn noOutline-text${
              isMessagesActive ? ' is-active' : ''
            }`}
            onClick={onMessages}
            aria-label="Messages"
            aria-current={isMessagesActive ? 'page' : undefined}
          >
            <span className="posts-mobile-floating-chrome__icon-wrap">
              <FiMessageSquare aria-hidden />
              {hasUnreadMessages ? (
                <span className="posts-mobile-floating-chrome__dot" aria-label="Unread messages" />
              ) : null}
            </span>
          </button>
          <button
            type="button"
            className={`posts-mobile-floating-chrome__bar-btn posts-mobile-floating-chrome__bar-btn--create noOutline-text${
              isCreateActive ? ' is-active' : ''
            }`}
            onClick={onCreate}
            aria-label="Create post"
            aria-current={isCreateActive ? 'page' : undefined}
          >
            <FiPlus aria-hidden />
          </button>
          <button
            type="button"
            className={`posts-mobile-floating-chrome__bar-btn noOutline-text${
              isSocialActive ? ' is-active' : ''
            }`}
            onClick={onSocial}
            aria-label="Followers and following"
            aria-current={isSocialActive ? 'page' : undefined}
          >
            <FiUsers aria-hidden />
          </button>
          <button
            type="button"
            className={`posts-mobile-floating-chrome__bar-btn noOutline-text${
              isProfileActive ? ' is-active' : ''
            }`}
            onClick={onProfile}
            aria-label="View profile"
            aria-current={isProfileActive ? 'page' : undefined}
          >
            {showProfileAvatar && profileAvatarSrc ? (
              <img
                src={profileAvatarSrc}
                alt=""
                className="posts-mobile-floating-chrome__bar-avatar"
                onError={(e) => {
                  applyProfileAvatarImgFallback(e.currentTarget, {
                    userId: profileUserId,
                    name: profileDisplayName,
                  });
                }}
              />
            ) : (
              <FiUser aria-hidden />
            )}
          </button>
        </nav>
      ) : null}
    </div>,
    document.body
  );
}
